import * as React from 'react'
import DialogContent from '@mui/material/DialogContent'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import { Title } from './styled'
import useTheme from '@mui/material/styles/useTheme'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import { Formik } from 'formik'
import { useHandlers, useInitialValues, useValidate } from './hooks'
import { ISaveServicesForLaterFormModel } from './FormContents/typings'
import { SaveServicesForLaterForm } from './SaveServicesForLaterForm'
import { Id } from 'react-toastify'

export type Props = {
  disabled: boolean
  entityId: number
  entityType: ENTITY_TYPES
  loading: boolean
  localMode: boolean
  onClose: () => void
  open: boolean
  serviceFrequencies: IServiceFrequency[]
  serviceLocations: LocationDTO[]
  totalServicesCount: number
  saveForLaterToastIdRef: React.MutableRefObject<Id | null>
}

export function SaveServicesForLaterDialog(props: Props) {
  const { onClose, open, totalServicesCount } = props

  const theme = useTheme()
  const { initialValues } = useInitialValues()
  const { onSubmit } = useHandlers({ ...props })
  const { validate } = useValidate({ totalServicesCount })

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          maxHeight: '700px',
        },
      }}
      sx={{ margin: `${theme.spacing(2.4)} auto` }}
    >
      <DialogTitle sx={{ padding: `${theme.spacing(1)} ${theme.spacing(2)}` }}>
        <Title>Save Services / Products For Later</Title>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          padding: 0,
        }}
      >
        <Formik<ISaveServicesForLaterFormModel>
          initialValues={initialValues}
          onSubmit={onSubmit}
          validate={validate}
        >
          <SaveServicesForLaterForm {...props} />
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
